export default {
  Title: 'Καταστήματα | Κατάστημα | Καταστήματα',

  List: {
    Title: 'Δείτε τα καταστήματά μας'
  },

  SelectStoreDialog: {
    Title   : 'Τα καταστήματά μας',
    Subtitle: 'Επιλέξτε κατάστημα'
  },

  Status: {
    Opened        : 'Ανοιχτά',
    Closed        : 'Κλειστά',
    ClosedNoOrders: 'Το κατάστημα είναι κλειστό και δεν δέχεται παραγγελίες!',
    NoDelivery    : 'Το κατάστημα δεν δέχεται παραγγελίες διανομής!',
    NoCollection  : 'Το κατάστημα δεν δέχεται παραγγελίες παραλαβής!'
  },

  OrderTime: {
    Suffix  : '@:Store.OrderTime.SuffixSM',
    SuffixXL: '@:Store.OrderTime.SuffixLG',
    SuffixLG: 'λεπτά',
    SuffixMD: '@:Store.OrderTime.SuffixSM',
    SuffixSM: 'λεπτά',
    SuffixXS: '\''
  },

  Notify: {
    Allergens: {
      Title: 'Πληροφορίες για αλλεργιογόνα',
      Body : 'Για κάθε προϊόν (προσυσκευασμένο ή γεύμα), οι πληροφορίες για τα συστατικά και τα αλλεργιογόνα παρέχονται στην πλατφόρμα από τα συνεργαζόμενα καταστήματα και, όπου είναι διαθέσιμες, εμφανίζονται στη σελίδα του προϊόντος πριν την ολοκλήρωση της παραγγελίας. Αν έχετε σοβαρή αλλεργία ή δυσανεξία, ελέγξτε τις πληροφορίες και επικοινωνήστε με το κατάστημα ή εστιατόριο πριν παραγγείλετε. Ο κατάλογος των αλλεργιογόνων είναι διαθέσιμος κατόπιν ζήτησης. Για αναλυτικότερες πληροφορίες σχετικά με τα αλλεργιογόνα στα τρόφιμα πατήστε {0}.'
    }
  }
}
